import { DiscriminatorElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class Discriminator extends DiscriminatorElement {}
export default Discriminator;